import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CharonService,
  HttpParamsType,
  IHttpOptions,
} from '@quickweb/connect-angular';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { OpenIdService } from '@quickweb/authenticator-angular';
import { GenericModalService } from './generic-modal.service';
import { TokenRefreshService } from './refreshTokenOpenIdService';

@Injectable({
  providedIn: 'root',
})
export class AgentApiService {
  isCharonSessionValid = false;
  REFRESH_TIME = 6000;

  constructor(
    private charon: CharonService,
    private openId: OpenIdService,
    private modalGeneric: GenericModalService,
    private refreshService: TokenRefreshService,
  ) {
    this.charonInitialize();
    this.refreshService.startFixedRefreshTimer();
  }

  private getHeaders() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.getToken(this.openId),
      'x-itau-apikey': environment.appClientId,
      'Content-type': 'application/json',
      'x-itau-correlationID': uuidv4(),
    });

    return headers;
  }

  private getOptions() {
    const options: IHttpOptions = {
      charonID: environment.charon.ID,
      entryPoint: environment.charon.entrypoint,
      useHref: false,
      headers: this.getHeaders(),
    };
    return options;
  }

  getTest() {
    this.charon.get('test', this.getOptions()).subscribe(console.log);
  }

  /**
   * Exemplo Teste de como utilizar um endpoint com query param.
   */
  getTestWithParam() {
    const params: HttpParamsType = {
      test: 'value',
    };
    this.charon
      .get('testParam', this.getOptionWithParams(params))
      .subscribe(console.log);
  }

  postCreateTicketItauShop(attachData: string) {
    const jsonBody = {
      attachData: attachData,
    };
    return this.charon.post(
      'itau-shop-create-ticket',
      jsonBody,
      this.getOptions(),
    );
  }

  /**
   * Responsavel por iniciar o charon e disponibilizar a lista de endpoints.
   */
  charonInitialize() {
    this.charon.setCryptography(environment.charon.isCrypt);
    return this.charon
      .initialize({
        charonID: environment.charon.ID,
        entryPoint: environment.charon.entrypoint,
        useHref: false,
        options: this.getOptions(),
      })
      .subscribe({
        next: (response) => {
          console.log(response);
          this.createModal(
            'Usuário autorizado com sucesso',
            'Usuário já pode mover para disponível e começar os atendimentos',
          );
        },
        error: (err) => {
          console.error(err);
          this.createModal(
            'Erro ao configurar o agent',
            'detectamos um erro ao identificar o agent, por favor recarregue a página',
          );
        },
      });
  }

  // Função para injertamos query params se necessário
  private getOptionWithParams(params: HttpParamsType) {
    const options = this.getOptions();
    options.params = params;
    return options;
  }

  private getToken(provider: OpenIdService) {
    let token = '';
    provider.getAccessToken().subscribe((e) => {
      token = e;
    });
    return token;
  }

  private createModal(title: string, description: string) {
    this.modalGeneric.createModal({
      title: title,
      description: description,
      allowCloseModal: true,
    });
  }
}
